<template>
  <div class="filter-bar">
    <span @click="select">
      年月 {{ yearmonth }}
      <i class="caret"></i>
    </span>
    <slot></slot>
  </div>
</template>

<script>
export default {
  data() {
    var year = new Date().getFullYear()
    var month = new Date().getMonth() + 1
    var yearmonth
    if(month < 10)yearmonth = year + '0' + month
    else yearmonth = year + '' + month

    return {
      yearmonth
    };
  },
  methods: {
    select() {
      var me = this,
        year = new Date().getFullYear(),
        month = new Date().getMonth() + 1,
        years = [],
        months = [
          {value: '01', label: '1月'}, 
          {value: '02', label: '2月'},
          {value: '03', label: '3月'},
          {value: '04', label: '4月'},
          {value: '05', label: '5月'},
          {value: '06', label: '6月'},
          {value: '07', label: '7月'},
          {value: '08', label: '8月'},
          {value: '09', label: '9月'},
          {value: '10', label: '10月'},
          {value: '11', label: '11月'},
          {value: '12', label: '12月'},
        ]
      for (let i = year - 20, len = year; i <= len; i++) {
        years.push({
          value: i,
          label: i + "年"
        });
      }
      me.$weui.picker(
        years,
        months,
        {
          title: "选择年月",
          defaultValue: [year, month],
          onConfirm: function (r) {
            me.yearmonth = r[0].value + r[1].value
            me.$emit("change", me.yearmonth);
          },
        }
      );
    }
  }
};
</script>

<style scoped>
.filter-bar {
  width: 100%;
  background: var(--weui-BG-2);
  box-sizing: border-box;
  text-align: center;
  font-size: 13px;
  padding: 11px 0 9px 0;
  color: #9b9b9b;
  margin-bottom: 1px;
  display: flex;
}
.filter-bar span {
  margin: 0 auto;
  flex: 1;
  position: relative;
}
</style>